import { API_NAME } from '../const';
import API from '@aws-amplify/api'
import { convertKeyNamesToCamelCase } from '../utils/utils'
import { checkCurrentAuthenticatedUser } from 'utils/currentAuthenticatedUserChecker'

interface FetchedOperationHistory {
  apply_id: number,
  created_at: string,
  created_by: string,
  id: number,
  operation_type: number,
  response_status: number,
  updated_at: string,
  updated_by: string,
  name: string
}

export interface OperationHistory {
  applyId: number,
  createdAt: string,
  createdBy: string,
  id: number,
  operationType: number,
  responseStatus: number,
  updatedAt: string,
  updatedBy: string,
  name: string
}

export async function getOperationHistories(applyId: string): Promise<OperationHistory[]> {
  await checkCurrentAuthenticatedUser()
  try {
    const result = await API.get(API_NAME, `/v2/${applyId}/operation-histories`, {})
    return result.data.map((history: FetchedOperationHistory) => {
      return convertKeyNamesToCamelCase(history)
    })
  } catch (err) {
    console.error(err)
    throw err
  }
}
